import axios from 'axios';
import { isEmpty } from 'lodash';
import {
  CROSSTAB_FEATUREID,
  QUICKREPORTS_FEATUREID,
  DATAHAUL_FEATUREID,
  STORIES_FEATUREID,
  MME_FEATUREID,
  GEOMAPPING_FEATUREID,
  BRAND_CATALYST_FEATUREID,
  SALES_CATALYST_FEATUREID,
  TURNKEY_OMNIBUS_FEATUREID,
  CORRCLUSTER_FEATUREID,
  CAMP_TGTS_FEATUREID,
} from '../constants';
import { getUser } from './loginActions';

export let ROOT_URL = '';
export let APP_ROOT_URL = '';
export let QTS_ROOT_URL = '';
export let CURRENT_YEAR = '';
export let API_GATEWAY_URL = '';
export let AUTH_CLIENTID = '';
export let AUTH_DOMAIN = '';
export let AUTH_LOGUT_RETURN = '';
export let MAX_RECORD_V3 = '';
export let MAX_CHILDRENS = '';
export let NIELSEN_TV_PATH_ID = '';
export let NIELSEN_TV_TEXT_PATH = '';
export let LANDING_PREFERENCES = {};
export let QUICK_REPORT_STUDY_TYPES_DEMOGRAPHICS_NOT_ALLOWED = [];
export let QUICK_REPORT_STUDY_TYPES_SEGMENTATION_NOT_ALLOWED = [];
export let QUICK_REPORT_STUDY_TYPES_MAP_NOT_ALLOWED = [];
export let IPSOS_DISABLED_STUDY_LIST = [];
export let ERROR_REFRESH_TIMER = '';
export let ERROR_INFINITE_REFRESH_TIMES = 1;
export let BASE_URL = '';
export let USAGE_TRACKING_ENABLED = true;
export let HOTJAR_TRACKING_ENABLED = false;
export const LOGIN_TOKEN = 'simmons-insights-token';
export let SURVEY_GIZMO_URL = '';
export let MME_TARGET_COUNT = 10; // updated to 10 for unit test passing
export let MME_TARGET_COUNT_IN_WORDS = '';
export let GEOMAP_REQUEST_COUNT = 5000;
export let MRC_ACCREDITED_STUDY_TYPES = [];
export let MRI_FUNCTION_STUDIES = [];
export let DATAHUB_SAMPLE_WARN_COUNT = 1000;
export let WS_BASE_URL = 'wss://insights.mrisimmons.com';
export let SPC2 = false;
export let BC_TREELOADEX = '';
export let BC_TREELOADEX_SEARCH = '';
export let QR_SMA_DISABLED_STUDIES = [];
export let QR_TS_DISABLED_STUDIES = [];
export let MRI_CONNECY_STUDY_STI = [];
export let EREADER_DISABLED_STUDY_LIST = [];

const setAut0Config = hostname => {
  if (
    hostname === 'http://si-integration' ||
    hostname === 'http://dev.insights.simmonsresearch.com' ||
    hostname === 'http://qa1.insights.simmonsresearch.com' ||
    hostname === 'http://dev.insights.mrisimmons' ||
    hostname === 'http://qa1.insights.mrisimmons' ||
    hostname === 'https://catalyst-integration.mrisimmons.net' ||
    hostname === 'https://catalyst-qa.mrisimmons.net'
  ) {
    AUTH_CLIENTID = 'clcz_bD6mCWiER99q07Y5O0M19XKPWNj';
    AUTH_DOMAIN = 'dev-simmonsinsights.auth0.com';
    AUTH_LOGUT_RETURN = 'customlogout';
    SURVEY_GIZMO_URL =
      'https://app.surveygizmo.com/login/initiatelogin/idp/xrK7b637KjXzz~15giysNP~xZVJrDjAenawVhTWR54A?r=/builder/build/id/';
  } else if (
    hostname === 'http://si-staging' ||
    hostname === 'http://staging.insights.simmonsresearch.com' ||
    hostname === 'http://staging.insights.mrisimmons' ||
    hostname === 'https://catalyst-staging.mrisimmons.net'
  ) {
    AUTH_CLIENTID = 'yupD784blIixdEHT3DSnsmMdMOWdk8f3';
    AUTH_DOMAIN = 'qa-simmonsinsights.auth0.com';
    AUTH_LOGUT_RETURN = 'customlogout';
    SURVEY_GIZMO_URL =
      'https://app.surveygizmo.com/login/initiatelogin/idp/lJYo_zB~zyXAx20QZYu~n5yG5qWJLrN23IBTeqbQ~MU?r=/builder/build/id/';
  } else if (
    hostname === 'https://simmonsbeta.com' ||
    hostname === 'https://insightsbeta.mrisimmons.com'
  ) {
    AUTH_CLIENTID = 'uB_h0pwj49Eqf1zTN3tIXl76DoJUFzGz';
    AUTH_DOMAIN = 'beta-simmonsinsights.auth0.com';
    AUTH_LOGUT_RETURN = 'customlogout';
    SURVEY_GIZMO_URL =
      'https://app.surveygizmo.com/login/initiatelogin/idp/6VneZMcxyjmJwefqU4AAyzWRTsI5wnJ0mi~0LZLcleQ?r=/builder/build/id/';
  } else if (
    hostname === 'https://simmonsinsights.com' ||
    hostname === 'https://insights.mrisimmons.com'
  ) {
    AUTH_CLIENTID = 'qkpSh4bKXQbQbAQO1bB1KVUtTFPVgK4j';
    AUTH_DOMAIN = 'simmonsinsights.auth0.com';
    AUTH_LOGUT_RETURN = 'customlogout';
    SURVEY_GIZMO_URL =
      'https://app.surveygizmo.com/login/initiatelogin/idp/1UCF3LLT_Ws5~8ZdvrWmsW~MPQR9NkrCG9XmSQFGszQ?r=/builder/build/id/';
  } else {
    console.error('Invalid Hostname, auth0 for environment not found.');
  }
};
/** to fetch the global environment varibales for each environment* */
export function getEnvironmentUrls() {
  window.trackingDataLayer = [];
  let res = {};
  return axios
    .get('/ui-config.json', { headers: { 'Cache-Control': 'no-cache' } })
    .then(response => {
      if (!isEmpty(response.data)) {
        res = response.data;
        // setting aut0 logout redirection configuration
        setAut0Config(res.BASE_URL);
        BASE_URL = res.BASE_URL;
        ROOT_URL = `${res.BASE_URL}/api-gateway/api/insights`;
        API_GATEWAY_URL = `${res.BASE_URL}/api-gateway`;
        WS_BASE_URL = res.WS_BASE_URL;
        APP_ROOT_URL = '';
        QTS_ROOT_URL = `${ROOT_URL}/qtsapi`;
        CURRENT_YEAR = res.CURRENT_YEAR;
        AUTH_LOGUT_RETURN = `${API_GATEWAY_URL}/${AUTH_LOGUT_RETURN}`;
        MAX_RECORD_V3 = res.MAX_RECORD_V3;
        MAX_CHILDRENS = res.MAX_CHILDRENS;
        NIELSEN_TV_PATH_ID = res.NIELSEN_TV_PATH_ID;
        NIELSEN_TV_TEXT_PATH = res.NIELSEN_TV_TEXT_PATH;
        QUICK_REPORT_STUDY_TYPES_DEMOGRAPHICS_NOT_ALLOWED =
          res.QUICK_REPORT_STUDY_TYPES_DEMOGRAPHICS_NOT_ALLOWED;
        QUICK_REPORT_STUDY_TYPES_SEGMENTATION_NOT_ALLOWED =
          res.QUICK_REPORT_STUDY_TYPES_SEGMENTATION_NOT_ALLOWED;
        QUICK_REPORT_STUDY_TYPES_MAP_NOT_ALLOWED =
          res.QUICK_REPORT_STUDY_TYPES_MAP_NOT_ALLOWED;
        IPSOS_DISABLED_STUDY_LIST = res.IPSOS_DISABLED_STUDY_LIST;
        ERROR_REFRESH_TIMER = res.ERROR_REFRESH_TIMER;
        ERROR_INFINITE_REFRESH_TIMES = res.ERROR_INFINITE_REFRESH_TIMES;
        USAGE_TRACKING_ENABLED = res.USAGE_TRACKING_ENABLED;
        HOTJAR_TRACKING_ENABLED = window.hj !== undefined;
        LANDING_PREFERENCES = [
          {
            url: '/essentials/crosstab',
            defaultFlag: false,
            id: CROSSTAB_FEATUREID,
          },
          {
            url: '/essentials/stories',
            defaultFlag: false,
            id: STORIES_FEATUREID,
          },
          {
            url: '/catalyst/brandcatalyst',
            defaultFlag: false,
            id: BRAND_CATALYST_FEATUREID,
          },
          {
            url: '/catalyst/salescatalyst',
            defaultFlag: false,
            id: SALES_CATALYST_FEATUREID,
          },
          {
            url: '/essentials/quickreports',
            defaultFlag: false,
            id: QUICKREPORTS_FEATUREID,
          },
          {
            url: '/essentials/datahaul',
            defaultFlag: false,
            id: DATAHAUL_FEATUREID,
          },
          {
            url: '/omnibus/turnkey',
            defaultFlag: false,
            id: TURNKEY_OMNIBUS_FEATUREID,
          },
          {
            url: '/essentials/mme',
            defaultFlag: false,
            id: MME_FEATUREID,
          },
          {
            url: '/essentials/geomap',
            defaultFlag: false,
            id: GEOMAPPING_FEATUREID,
          },
          {
            url: '/essentials/correspondencecluster',
            defaultFlag: false,
            id: CORRCLUSTER_FEATUREID,
          },
          {
            url: '/datahub/targets',
            defaultFlag: false,
            id: CAMP_TGTS_FEATUREID,
          },
        ];
        MME_TARGET_COUNT = res.MME_TARGET_COUNT;
        MME_TARGET_COUNT_IN_WORDS = res.MME_TARGET_COUNT_IN_WORDS;
        GEOMAP_REQUEST_COUNT = res.GEOMAP_REQUEST_COUNT;
        MRC_ACCREDITED_STUDY_TYPES = res.MRC_ACCREDITED_STUDY_TYPES;
        MRI_FUNCTION_STUDIES = res.MRI_FUNCTION_STUDIES
          ? res.MRI_FUNCTION_STUDIES
          : [];
        DATAHUB_SAMPLE_WARN_COUNT = res.DATAHUB_SAMPLE_WARN_COUNT
          ? res.DATAHUB_SAMPLE_WARN_COUNT
          : 1000;
        SPC2 = res.SPC2 ? res.SPC2 : false;
        BC_TREELOADEX = res.BC_TREELOADEX
          ? res.BC_TREELOADEX
          : '/dictionary/treeloadex';
        BC_TREELOADEX_SEARCH = res.BC_TREELOADEX_SEARCH
          ? res.BC_TREELOADEX_SEARCH
          : '/dictionary/search';
        QR_SMA_DISABLED_STUDIES = res.QR_SMA_DISABLED_STUDIES;
        QR_TS_DISABLED_STUDIES = res.QR_TS_DISABLED_STUDIES;
        MRI_CONNECY_STUDY_STI = res.MRI_CONNECY_STUDY_STI;
        EREADER_DISABLED_STUDY_LIST = res.EREADER_DISABLED_STUDY_LIST;
        return true;
      }
      return false;
    })
    .catch(error => {
      console.warn(`Initial call failed: ${error}`);
      return false;
    });
}
export function login(store) {
  return store.dispatch(getUser());
}
// exporting urls
export const USAGE_TRACKER_ERROR_URL =
  '/api/usage-tracking-service/track-error';
export const USER_SERVICE_URL = '/api/user-service';
export const USAGE_TRACKER_API_URL = '/api/usage-tracking-service/track';
export const SEARCH_USAGE_TRACKER_API_URL =
  '/api/usage-tracking-service/track-search';
export const SOCKET_URL = '/api/datahaul-service';
export const W3_1999_XLINK = 'http://www.w3.org/1999/xlink';
export const W3_2000_SVG = 'http://www.w3.org/2000/svg';
export const SIMMONS_RESEARCH_PROD_LINK = 'https://www.mrisimmons.com/';
export const DEFAULT_LANDING_PAGE = '/essentials/crosstab';
export const SIMMONS_CATALYST_FOOTER = 'Simmons Research LLC';
export const BLOG_URL = 'https://www.mrisimmons.com/wp-json/wp/v2/posts?_embed';
export const SMART_VIEW = true;
export const TEASER_EMAIL_CATALYST = 'clientservices.ms@mrisimmons.com';
export const LOGGED_IN = 'LOGGED_IN';

export const PREMIER_OMNIBUS_URL =
  'https://www.mrisimmons.com/solutions/dedicated-solutions/premier-omnibus/';
